const getters = {
  recentProjects: state => state.recentProjects,
  projects: state => state.projects,
  getProjectModality: state => state.ActiveProjectModality,
  selectProfile: state => state.selectProfile,
  isSaldobrasata: state => state.isSaldobrasata,
  isVerifica: state => state.isVerifica,
  isSelezione: state => state.isSelezione,
  selectionOutput: state => state.selectionOutput,
  currentProject: state => state.currentProject,
  selectionResults: state => state.selectionResults,
  defValues: state => state.defValues,
  bloccaCalcolo: state => state.bloccaCalcolo
};

export default getters;
